module.exports = __webpack_public_path__ + "img/company-logo.d6aa123c.png";